import { formatCompact3SignificantDigits, MetricCard } from "@quortex/front-common"
import { useMemo } from "react"

interface TopGeoSegmentsCardProps {
  viewersPerSegment: api.switchns.ViewersPerSegment[]
  className?: string
}

const TopGeoSegmentsCard = ({ viewersPerSegment, ...props }: TopGeoSegmentsCardProps) => {
  const segments = useMemo(
    () => viewersPerSegment.sort((a, b) => b.viewersCount - a.viewersCount).slice(0, 3),
    [viewersPerSegment]
  )
  return (
    <MetricCard hasNoData={viewersPerSegment.length === 0} title="Top geo segments" {...props}>
      <div className="flex flex-col gap-xs">
        {segments[0] && (
          <div className="flex items-center justify-between">
            <div className="text-grey-600 text-xs">{segments[0]?.segmentName}</div>
            <div className="font-medium">
              {formatCompact3SignificantDigits(segments[0].viewersCount)}
            </div>
          </div>
        )}
        {segments[1] && (
          <div className="flex items-center justify-between">
            <div className="text-grey-600 text-xs">{segments[1].segmentName}</div>
            <div className="font-medium">
              {formatCompact3SignificantDigits(segments[1].viewersCount)}
            </div>
          </div>
        )}
        {segments[2] && (
          <div className="flex items-center justify-between">
            <div className="text-grey-600 text-xs">{segments[2].segmentName}</div>
            <div className="font-medium">
              {formatCompact3SignificantDigits(segments[2].viewersCount)}
            </div>
          </div>
        )}
      </div>
    </MetricCard>
  )
}

export default TopGeoSegmentsCard
